import React from "react";
import {
  FaTwitter,
  FaInstagram,
  FaGithub,
  FaArrowDown,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-scroll";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__bg">
        <div className="hero__glow"></div>
      </div>

      <div className="hero__layout">
        <div className="hero__content">
          <div className="hero__eyebrow">
            <span className="hero__status-dot"></span>
            Open to work
          </div>
          <p className="hero__kicker">Software developer · Augsburg, Germany</p>
          <h1 className="hero__name">
            Building software
            <span>that works at scale.</span>
          </h1>
          <p className="hero__desc">
            I'm Alex Rodriguez, a full-stack developer at CHECK24. I turn complex
            product requirements into clean, reliable and human-centered digital
            experiences.
          </p>
          <div className="hero__actions">
            <Link
              to="contact"
              smooth={true}
              duration={600}
              className="hero__btn hero__btn--primary"
            >
              Let's work together <FaArrowRight />
            </Link>
            <Link
              to="works"
              smooth={true}
              duration={600}
              className="hero__btn hero__btn--outline"
            >
              Explore my work
            </Link>
          </div>
          <div className="hero__socials">
            <span>Follow</span>
            <a href="https://github.com/Sterki" aria-label="GitHub" target="_blank" rel="noreferrer">
              <FaGithub />
            </a>
            <a href="https://twitter.com/alexbyrod" aria-label="Twitter" target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
            <a href="https://www.instagram.com/alexbyrod_7" aria-label="Instagram" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>

        <aside className="hero__panel" aria-label="Professional overview">
          <div className="hero__panel-top">
            <span>Current focus</span>
            <span>01 / 03</span>
          </div>
          <div className="hero__panel-code">
            <span className="hero__code-comment">{"// Engineering with intent"}</span>
            <p><span>const</span> developer = {"{"}</p>
            <p>&nbsp;&nbsp;focus: <strong>"full-stack"</strong>,</p>
            <p>&nbsp;&nbsp;quality: <strong>"non-negotiable"</strong>,</p>
            <p>&nbsp;&nbsp;impact: <strong>"measurable"</strong></p>
            <p>{"}"};</p>
          </div>
          <div className="hero__stats">
            <div><strong>10+</strong><span>Years in tech</span></div>
            <div><strong>4</strong><span>Companies</span></div>
            <div><strong>2</strong><span>Continents</span></div>
          </div>
          <div className="hero__panel-footer">
            <span>React · PHP · TypeScript · Docker</span>
          </div>
        </aside>
      </div>

      <div className="hero__scroll">
        <Link to="about" smooth={true} duration={600}>
          <span>Scroll down</span>
          <FaArrowDown />
        </Link>
      </div>
    </section>
  );
}
